import { Action } from 'redux';
import { Service } from 'types/Service';

export const SERVICES_RESET_ACTION_TYPE = 'services/reset';
export const SERVICES_ERROR_ACTION_TYPE = 'services/error';

export const SERVICES_FETCH_ACTION_TYPE = 'services/fetch_start';
export const SERVICES_FETCH_SUCCESS_ACTION_TYPE = 'services/fetch_success';

interface ServicesResetAction extends Action<typeof SERVICES_RESET_ACTION_TYPE> {}

interface ServicesFetchAction extends Action<typeof SERVICES_FETCH_ACTION_TYPE> {}
interface ServicesFetchSuccessAction extends Action<typeof SERVICES_FETCH_SUCCESS_ACTION_TYPE> {
    payload: {
        services: Array<Service>;
    };
}

interface ServicesErrorAction extends Action<typeof SERVICES_ERROR_ACTION_TYPE> {}

export type ServicesAction =
    | ServicesResetAction
    | ServicesFetchAction
    | ServicesFetchSuccessAction
    | ServicesErrorAction;
